<div class="unsupported-file-dialog">
  <h3 class="unsupported-file-dialog__title">
    {{ 'models.unsupported-file-type-dialog.error-title' | translate }}
  </h3>

  <p class="unsupported-file-dialog__message">
    {{ 'models.unsupported-file-type-dialog.message' | translate }}
  </p>

  <div class="unsupported-file-dialog__footer">
    <button
      type="button"
      hlmBtn
      size="lg"
      class="unsupported-file-dialog__close-btn"
      (click)="onClose()"
    >
      {{ 'models.unsupported-file-type-dialog.ok' | translate }}
    </button>
  </div>
</div>
